import React, {
  ReactChild,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { CONFIG } from './config'
import './styles.scss'
import mapboxgl from 'mapbox-gl'
import { initOptionsT } from './types'

export const MapContext = React.createContext<mapboxgl.Map | null>(null)

export const MapboxMap = ({
  initOptions,
  children,
  token,
  getMap,
}: {
  initOptions: initOptionsT
  children?: ReactChild
  token: string
  getMap?: (a: mapboxgl.Map) => void
}) => {
  const mapContainer = useRef<HTMLDivElement | null>(null)
  const [map, setMap] = useState<mapboxgl.Map | undefined>()
  const MapContainer = useRef<HTMLDivElement | undefined>()
  useEffect(() => {
    console.warn('MapboxMap init')
    if (!mapContainer.current) return
    mapboxgl.accessToken = token
    const map = new mapboxgl.Map({
      ...initOptions,
      ...{
        container: mapContainer.current,
      },
    })
    map.on('load', () => {
      console.warn('Map load')
      map.maincontainer = MapContainer
      map.popups = {}

      // Create a popup, but don't add it to the map yet.
      const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      })

      map.on('mouseenter', 'parcs', function (e: any) {
        // Change the cursor style as a UI indicator.
        map.getCanvas().style.cursor = 'pointer'

        const coordinates = e.features[0].geometry.coordinates.slice()

        // Populate the popup and set its coordinates
        // based on the feature found.
        popup
          .setLngLat(coordinates[0][0])
          .setHTML(
            `
    <div>
      <b>${e.features[0].properties.SITE}</b>
    </div>
    <div>
      ${e.features[0].properties.PLANIFICAT}
    </div>`
          )
          .addTo(map)
      })

      map.on('mouseleave', 'parcs', function () {
        map.getCanvas().style.cursor = ''
        popup.remove()
      })
    })
    setMap(map)

    if (getMap) getMap(map)
  }, [mapContainer])

  return (
    <>
      <div className='MapboxMap' ref={MapContainer as any}>
        <div ref={mapContainer} id='map' />
        {map && (
          <MapContext.Provider value={map}>
            {children && <div className='MapboxMapOverlay'>{children}</div>}
          </MapContext.Provider>
        )}
      </div>
    </>
  )
}
